import cn from 'classnames';
import { noop } from 'lodash';
import { prevented } from 'src/utils/event';
import { Button, BUTTON_THEMES } from 'ht-styleguide';
import { CtaProps } from './productCard.types';
import styles from './productCard.module.scss';

const ProductCardCta = ({ onButtonClick = noop, linkText, buttonText, onLinkClick = noop, showCta }: CtaProps) => {
  if (!showCta) {
    return null;
  }

  return (
    <div className={cn(styles.cta, 'paddingTop-small2 marginLeft-small1 marginRight-small1 paddingBottom-small2')}>
      <Button theme={BUTTON_THEMES.SECONDARY} className={styles.ctaButton} small onClick={prevented(onButtonClick)}>
        {buttonText}
      </Button>
      <a className={styles.ctaLink} onClick={prevented(onLinkClick)} href="">
        {linkText}
      </a>
    </div>
  );
};

export default ProductCardCta;
